module.exports = __webpack_public_path__ + "img/InhaltsElemente.b62b5b19.svg";